<!-- periodo-contrato-dialog.component.html -->
<div class="position-relative">
  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  <h1 mat-dialog-title><strong>Período contrato</strong>
  </h1>

  <div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <br>

    <form [formGroup]="periodoContratoForm">
      <ngx-spinner [zIndex]=100 name="spPeriodoContrato" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
        type="ball-atom" [fullScreen]="false">
      </ngx-spinner>

      <mat-tab-group [(selectedIndex)]="selectedTab" class="custom-tabs">

        <!-- Tab: Información Básica -->
        <mat-tab>
          <ng-template mat-tab-label>
            Información Básica
          </ng-template>

          <div class="tab-content">
            <mat-card class="info-card">
              <mat-card-content>
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-form-field class="full-width">
                      <mat-label>Número de Período</mat-label>
                      <input type="number" formControlName="periodo" matInput min="1">
                      <mat-error *ngIf="f.periodo.errors?.required">
                        Este campo es <strong>requerido</strong>
                      </mat-error>
                      <mat-error *ngIf="f.periodo.errors?.min">
                        El período debe ser mayor a 0
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-form-field class="full-width">
                      <mat-label>Mes</mat-label>
                      <mat-select formControlName="periodoMes">
                        <mat-option [value]="1">Enero</mat-option>
                        <mat-option [value]="2">Febrero</mat-option>
                        <mat-option [value]="3">Marzo</mat-option>
                        <mat-option [value]="4">Abril</mat-option>
                        <mat-option [value]="5">Mayo</mat-option>
                        <mat-option [value]="6">Junio</mat-option>
                        <mat-option [value]="7">Julio</mat-option>
                        <mat-option [value]="8">Agosto</mat-option>
                        <mat-option [value]="9">Septiembre</mat-option>
                        <mat-option [value]="10">Octubre</mat-option>
                        <mat-option [value]="11">Noviembre</mat-option>
                        <mat-option [value]="12">Diciembre</mat-option>
                      </mat-select>
                      <mat-error *ngIf="f.periodoMes.errors?.required">
                        Este campo es <strong>requerido</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-form-field class="full-width">
                      <mat-label>Año</mat-label>
                      <input type="number" formControlName="periodoAnio" matInput>
                      <mat-error *ngIf="f.periodoAnio.errors?.required">
                        Este campo es <strong>requerido</strong>
                      </mat-error>
                      <mat-error *ngIf="f.periodoAnio.errors?.min || f.periodoAnio.errors?.max">
                        Año fuera del rango permitido
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6 col-md-12">
                    <mat-form-field class="full-width">
                      <mat-label>Importe Alquiler</mat-label>
                      <span matPrefix>$ </span>
                      <input type="text" mask="separator.2" thousandSeparator="," formControlName="importeAlquiler"
                        matInput>
                      <mat-error *ngIf="f.importeAlquiler.errors?.required">
                        Este campo es <strong>requerido</strong>
                      </mat-error>
                      <mat-error *ngIf="f.importeAlquiler.errors?.min">
                        El importe debe ser mayor a 0
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-6 col-md-12">
                    <mat-form-field class="full-width">
                      <mat-label>Valor Ajuste</mat-label>
                      <input type="number" step="0.001" formControlName="valorAjuste" matInput>
                      <mat-hint>Valor decimal para ajustes</mat-hint>
                      <mat-error *ngIf="f.valorAjuste.errors?.min">
                        El valor no puede ser negativo
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-tab>

        <!-- Tab: Auditoría -->
        <mat-tab>
          <ng-template mat-tab-label>
            Auditoría
          </ng-template>

          <div class="tab-content">
            <mat-card class="audit-card">
              <mat-card-content>
                <div class="audit-info">
                  <div class="audit-item">
                    <div class="audit-details">
                      <strong>Fecha de Creación:</strong>
                      <span>{{periodoContratoDetailDto?.fechaAlta | date:'dd/MM/yyyy HH:mm'}}</span>
                    </div>
                  </div>

                  <div class="audit-item" *ngIf="periodoContratoDetailDto?.fechaModificacion">
                    <div class="audit-details">
                      <strong>Última Modificación:</strong>
                      <span>{{periodoContratoDetailDto.fechaModificacion | date:'dd/MM/yyyy HH:mm'}}</span>
                    </div>
                  </div>

                  <div class="audit-item">
                    <div class="audit-details">
                      <strong>Fecha Pago:</strong>
                      <span>{{periodoContratoDetailDto.fechaPago | date:'dd/MM/yyyy'}}</span>
                    </div>
                  </div>
                  <div class="audit-item">
                    <div class="audit-details">
                      <strong>Fecha Liquidación:</strong>
                      <span>{{periodoContratoDetailDto.fechaLiquidacion | date:'dd/MM/yyyy'}}</span>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-tab>
      </mat-tab-group>

      <!-- Botones de acción -->
      <mat-divider class="action-divider"></mat-divider>
      <div class="dialog-actions">
        <button mat-raised-button color="primary" [disabled]="!periodoContratoForm.valid || estaPagadoOLiquidado()"
          (click)="onSubmit()">
          <mat-icon>save</mat-icon>
          Guardar
        </button>

        <button mat-stroked-button color="warn" (click)="closeDialog()">
          <mat-icon>close</mat-icon>
          Cancelar
        </button>
      </div>
    </form>
  </div>
</div>
